import { Injectable } from "@angular/core";
import { Headers, Http } from "@angular/http";
import { Observable, Subject } from "rxjs";
import { AppPreferences } from "../../shared/local/app-preferences.local";

@Injectable()
export class GoogleAccountBloc {

  private model = 'sso';
  private url = 'https://api.greatdayhr.com/gd-signin-dev';

  constructor(
    private http: Http,
    private appPreferences: AppPreferences,
  ) {

  }

  /**
   * GET Lists
   */
  private lists(serverUrl: string, serverToken: string): Observable<any> {
    return Observable.create((observer: Subject<any>) => {
      const isWebview = localStorage.getItem('webOpenFromWebview');
      const headers = new Headers();
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      headers.append('server-url', serverUrl);
      headers.append('server-token', serverToken);
      if (isWebview) {
        headers.append("app", "gd8");
      }

      this.http.get(`${this.url}/${this.model}/lists`, { headers: headers })
        .timeout(10000)
        .subscribe(async res => {
          const result = res.json();
          observer.next(result.data);
          observer.complete();
        }, error => {
          observer.error(error)
        })
    })
  }

  /**
   * SET Link
   */
  private link(serverUrl: string, serverToken: string, provider: string, code: string): Observable<any> {
    return Observable.create((observer: Subject<any>) => {
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('server-url', serverUrl);
      headers.append('server-token', serverToken);
      const isWebview = localStorage.getItem('webOpenFromWebview');
      if (isWebview) {
        headers.append("app", "gd8");
      }

      this.http.post(`${this.url}/${this.model}/lists/link`, { provider: provider, code: code }, { headers: headers })
        .timeout(10000)
        .subscribe(async res => {
          observer.next(res)
          observer.complete()
        }, error => {
          observer.error(error)
        })
    })
  }

  /**
   * SET Unlink
   */
  private unlink(serverUrl: string, serverToken: string, provider: string, codename: string): Observable<any> {
    return Observable.create((observer: Subject<any>) => {
      const isWebview = localStorage.getItem('webOpenFromWebview');
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('server-url', serverUrl);
      headers.append('server-token', serverToken);
      if (isWebview) {
        headers.append("app", "gd8");
      }

      this.http.post(`${this.url}/${this.model}/lists/unlink`, { provider: provider, codename: codename }, { headers: headers })
        .timeout(10000)
        .subscribe(async res => {
          observer.next(res)
          observer.complete()
        }, error => {
          observer.error(error)
        })
    })
  }

  /**
   * GET Link SSO
   */
  private uri(provider: string): Observable<any> {
    return Observable.create((observer: Subject<any>) => {
      this.http.get(`${this.url}/${this.model}/uri?provider=${provider}`)
        .timeout(10000)
        .subscribe(async res => {
          const result = res.json();
          observer.next(result);
          observer.complete();
        }, error => {
          observer.error(error)
        })
    })
  }

  /**
   * GET Link SSO
   */
  private uriLogin(provider: string): Observable<any> {
    return Observable.create((observer: Subject<any>) => {
      this.http.get(`${this.url}/${this.model}/login/uri?provider=${provider}`)
        .timeout(10000)
        .subscribe(async res => {
          const result = res.json();
          observer.next(result);
          observer.complete();
        }, error => {
          observer.error(error)
        })
    })
  }

  /**
   * SET Link
   */
  private login(provider: string, code: string): Observable<any> {
    return Observable.create((observer: Subject<any>) => {
      const isWebview = localStorage.getItem('webOpenFromWebview');
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      if (isWebview) {
        headers.append("app", "gd8");
      }

      this.http.post(`${this.url}/${this.model}/login`, { provider: provider, code: code }, { headers: headers })
        .timeout(10000)
        .subscribe(async res => {
          observer.next(res)
          observer.complete()
        }, error => {
          observer.error(error)
        })
    })
  }

  async getLinkSSO(provider: string) {
    try {
      return await this.uri(provider).toPromise();
    } catch (error) {
      throw error;
    }
  }

  /**
   * Link
   */

  async getLoginSSO(provider: string) {
    try {
      return await this.uriLogin(provider).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async getListSSO() {
    try {
      const auth = await this.appPreferences.getAuth();
      const saas = await this.appPreferences.getSaasData();
      return await this.lists(saas.storedPrelogin.GOPATHNEW, auth.id).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async setLinkSSO(provider: any, code: any) {
    try {
      const auth = await this.appPreferences.getAuth();
      const saas = await this.appPreferences.getSaasData();
      return await this.link(saas.storedPrelogin.GOPATHNEW, auth.id, provider, code).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async unLinkSSO(provider: any, codename: any) {
    try {
      const auth = await this.appPreferences.getAuth();
      const saas = await this.appPreferences.getSaasData();
      return await this.unlink(saas.storedPrelogin.GOPATHNEW, auth.id, provider, codename).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async setLoginGoogle(provider: any, code: any) {
    try {
      return await this.login(provider, code).toPromise();
    } catch (error) {
      throw error;
    }
  }

  /**
   * Login
   */

  async getLoginLinkSSO(provider: string) {
    try {
      return await this.uri(provider).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async setLoginSSO(provider: any, code: any) {
    try {
      return await this.login(provider, code).toPromise();
    } catch (error) {
      throw error;
    }
  }

}


// WEBPACK FOOTER //
// ./src/bloc/settings/google-account.bloc.ts